export const routes = [
  {
    path: '/',
    icon: "fa fa-long-arrow-left",
    title: "До порталу"
  },
  {
    path: "/administration/institution-reviews",
    icon: "fa fa-address-book",
    title: "Звернення"
  },
  {
    path: "/administration/staff-reviews",
    icon: "fa fa-address-book",
    title: "Відгуки про лікарів"
  },
  {
    path: "/administration/rating",
    icon: "fa fa-address-book",
    title: "Оцінки лікарів"
  }
];



// WEBPACK FOOTER //
// ./src/administration/routes.js